
import React from 'react';
import { FileUpIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  onSelectFile: () => void;
  onDownloadTemplate: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onSelectFile, onDownloadTemplate }) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-8 text-center">
        <FileUpIcon className="h-10 w-10 text-gray-400 mb-4" />
        <h3 className="text-lg font-medium mb-2">No File Selected</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Upload an Excel file (.xlsx or .xls) with your product details. Include columns for product_name, measuring_unit, category_name, and optionally description.
        </p>
        <div className="space-y-4">
          <div className="flex space-x-2 justify-center">
            <Button onClick={onSelectFile}>
              Select File
            </Button>
            <Button variant="outline" onClick={onDownloadTemplate}>
              Download Template
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">
            Make sure your Excel file has the required columns. Use our template for the correct format.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
